import { Auth } from 'firebase/auth';
import { IServiceFactory } from '../IServiceFactory';
import { IInstanceService } from '../IInstanceService';
import { InstanceService } from './InstanceService';
import { IAuthService } from '../IAuthService';
import { AuthService } from './AuthService';
import { Firestore } from 'firebase/firestore';

export class ServiceFactory implements IServiceFactory {
  private instanceService: IInstanceService;
  private authService: IAuthService;
  
  constructor(database: Firestore, auth: Auth) {
    this.instanceService = new InstanceService(database, 'instances');
    this.authService = new AuthService(auth);
  }

  getInstanceService(): IInstanceService {
    return this.instanceService;
  }

  getAuthService(): IAuthService {
    return this.authService;
  }
}